import $ from 'jquery/src/jquery';
import 'jquery-ui/ui/widgets/accordion';
import 'isotope-layout/dist/isotope.pkgd';
import 'select2';
import 'select2/dist/css/select2.min.css';

$(document).ready(function($) {

    $('.articlesListing').each(function (index, element) {
        const $listing = $(element);
        const $filterDropdown = $listing.find('select');
        const $grid = $('[class*="__items"]');
        const itemSelector = '.articlesListing__item';
        const $items = $grid.find(itemSelector);
        const $pagination = $listing.find('[class*="__pagination"]');
        const step = window.outerWidth < 640 ? 4 : ( window.outerWidth < 1260 ? 6 : 9 );
        let visibleItemsNum = step;
        let filterValue = '*';
        let matchCounter = 0;

        const $isotope = $grid.isotope({
            itemSelector: itemSelector,
            layoutMode: 'fitRows',
            filter: isotopeFilter
        });

        $filterDropdown.
            select2({
                minimumResultsForSearch: Infinity,
                width: '100%'
            })
            .on('change', function () {
                filterValue = $(this).val();
                applyIsotopeFilter();
            })
            .trigger('change');

        function resetItemsHeight() {
            $items.css('height', '');
            $items.each(function (index, element) {
                const $item = $(element);
                $item.css('height', $item.outerHeight());
            });
        }

        function showMoreItems() {
            visibleItemsNum = visibleItemsNum + step;
            matchCounter = 0;
            $grid.isotope();
            const items = $grid.isotope('getFilteredItemElements');
            $(items).css('visibility', '');
            $pagination.toggle( matchCounter > visibleItemsNum );
        }

        function applyIsotopeFilter() {
            resetItemsHeight();
            matchCounter = 0;
            $grid.isotope();
            const items = $grid.isotope('getFilteredItemElements');
            $(items).css('visibility', '');
            $pagination.toggle( matchCounter > visibleItemsNum );
        }

        function alignItemsHeight() {
            let itemsInRow = [];
            let rowHeight = 0;
            const filteredElements = $grid.isotope('getFilteredItemElements');
            resetItemsHeight();
            filteredElements.forEach(function (element, index) {
                const $item = $(element);
                if ( index > 0 ) {
                    if ( $item.offset().top === $(filteredElements[index-1]).offset().top ) {
                        itemsInRow.push( $item );
                        rowHeight = $item.outerHeight() > rowHeight ? $item.outerHeight() : rowHeight;
                    }
                    else {
                        itemsInRow.forEach(function ($item) {
                            $item.css('height', rowHeight);
                        });
                        itemsInRow = [ $item ];
                        rowHeight = $item.outerHeight();
                    }
                } else {
                    itemsInRow.push( $item );
                    rowHeight = $item.outerHeight();
                }
                if ( index === filteredElements.length - 1 ) {
                    itemsInRow.forEach(function ($item) {
                        $item.css('height', rowHeight);
                    });
                }
            });
        }

        function isotopeFilter() {
            const match = filterValue === '*' || $(this).hasClass( filterValue );
            if ( match ) {
                matchCounter++;
            }
            return match && matchCounter <= visibleItemsNum;
        }

        function hashHandler() {
            if ( location.hash && $items.filter('.' + location.hash.substring(1)).length ) {
                filterValue = '.' + location.hash.substring(1);
                applyIsotopeFilter();
            }
        }

        alignItemsHeight();
        hashHandler();
        $isotope.on( 'layoutComplete', alignItemsHeight);
        $pagination.on('click', 'button', showMoreItems);
    });
});